<div class="d-flex flex-column gap-3">
    <div>
        <div class="row">
            <div class="col fw-bold">Weight</div>
            <div class="col fw-bold">Unit of weight measurement</div>
        </div>
        <div class="row">
            <div class="col">
                <input (input)="setWeight($event)"
                    [value]="weight || ''"
                    class="form-control m-auto"
                    type="number">
            </div>
            <div class="col">
                <button aria-controls="weightMeasurementUnitCollapse"
                    [ngClass]="{'is-invalid': weight && !unit}"
                    aria-expanded="false"
                    class="btn btn-info dropdown-toggle w-100 btn-input-height"
                    data-bs-target="#weightMeasurementUnitCollapse"
                    data-bs-toggle="collapse"
                    id="weightMeasurementUnitDropdownMenuButton"
                    type="button">{{ (unit | weightMeasurementUnit) || "Select" }}</button>
                <div class="collapse" id="weightMeasurementUnitCollapse">
                    @for (unit of weightMeasurementUnits | keyvalue; track unit.value) {
                        <div (click)="setWeightMeasurementUnit(unit.value)"
                            aria-controls="weightMeasurementUnitCollapse"
                            class="btn card m-1"
                            data-bs-target="#weightMeasurementUnitCollapse"
                            data-bs-toggle="collapse">{{ unit.value | weightMeasurementUnit }}</div>
                    }
                </div>
            </div>
        </div>
    </div>

    <div>
        <div class="row">
            <div class="col fw-bold">Date of weight measurement</div>
        </div>
        <div class="row">
            <div class="col">
                <ngb-datepicker #dp
                    [classList]="'justify-content-center'"
                    [displayMonths]="1"
                    [maxDate]="today"
                    [ngModel]="date"
                    (dateSelect)="setDate($event)"
                    outsideDays="hidden"></ngb-datepicker>
            </div>
        </div>
    </div>
</div>
